module.exports = require("handlebars/runtime");


//////////////////
// WEBPACK FOOTER
// external "handlebars/runtime"
// module id = 2
// module chunks = 0